import type { ApiClient } from "../../../infrastructure/http/apiClient";

const AUTH_LOGOUT_PATH = "/api/v1/auth/logout";

export async function logoutSession(apiClient: ApiClient): Promise<void> {
  await apiClient.post<void, Record<string, never>>(AUTH_LOGOUT_PATH, {});
}
